import { ROUTES_NAME } from "../../../config/constants";
import { ACCESS_TOKEN } from "../../../constants";
import { authenticatedFetch } from "../../../util/authenticatedFetch";
import {
  FULLFILLMENT_ERROR,
  FULLFILLMENT_REQUEST,
  FULLFILLMENT_RESET,
  FULLFILLMENT_SUCCESS,
} from "./ActionType";

let requestSequence = 0;

const createRequestMeta = (shopId) => {
  const normalizedShopId = String(shopId ?? "");
  requestSequence += 1;
  return {
    shopId: normalizedShopId,
    requestId: `fulfillmentChecker:${normalizedShopId}:${Date.now()}:${requestSequence}`,
  };
};

const readResponsePayload = async (response) => {
  if (typeof response.text === "function") {
    const text = await response.text();
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch (_error) {
      return { message: text };
    }
  }
  if (typeof response.json === "function") return response.json();
  return null;
};

const responseError = (payload, response) =>
  [payload?.message, payload?.error, payload?.detail].find(
    (value) => typeof value === "string" && value.trim()
  ) || `Fulfillment checker request failed (${response.status})`;

export const getFullfillmentCheckerData = (payload) => async (dispatch) => {
  const target = {
    orderId: payload?.orderId ?? null,
    shopId: String(payload?.id ?? payload?.shopId ?? ""),
    orderName: payload?.orderName ?? null,
  };
  const meta = createRequestMeta(target.shopId);
  dispatch({ type: FULLFILLMENT_REQUEST, meta });

  try {
    const response = await authenticatedFetch(
      `${process.env.REACT_APP_BACKEND_API_URL}${ROUTES_NAME.fullfillment()}`,
      {
        method: "POST",
        body: JSON.stringify({
          storeOrderId: target.orderId,
          storeId: target.shopId,
          orderName: target.orderName,
        }),
        credentials: "include",
        headers: {
          Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
          "Content-Type": "application/json",
          Origin: `${process.env.REACT_APP_URL}`,
        },
      }
    );
    const data = await readResponsePayload(response);
    if (!response.ok) throw new Error(responseError(data, response));

    dispatch({ type: FULLFILLMENT_SUCCESS, payload: data, meta });
    return { ok: true, payload: data, meta };
  } catch (error) {
    const message = error?.message || "Fulfillment checker request failed";
    dispatch({ type: FULLFILLMENT_ERROR, payload: message, meta });
    return { ok: false, error: message, meta };
  }
};

export const resetFullfillmentChecker = () => ({ type: FULLFILLMENT_RESET });
